// useAuthentication.ts
import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

export const useAuthentication = () => {
  const { instance } = useMsal();
  const [handlingRedirect, setHandlingRedirect] = useState(false);

  useEffect(() => {
    const handleRedirectPromise = async () => {
      try {
        await instance.handleRedirectPromise();
      } catch (err) {
        console.error('An error occurred while handling the redirect:', err);
      } finally {
        setHandlingRedirect(false);
      }
    };

    setHandlingRedirect(true);
    handleRedirectPromise().catch((error) => {
      console.error(
        'An error occurred while running handleRedirectPromise:',
        error,
      );
    });
  }, [instance]);

  return handlingRedirect;
};
